import { useTranslation } from 'react-i18next';

import { DataPanel, NgButton } from '@/ui';
import type { IncidentAgency } from '@/signalr';
import { IncidentPurposeBadge } from '@/features/shared/IncidentPurposeBadge';
import { openEditIncidentLabelDialog } from '../../actions';
import { IncidentTimePanelItems } from './IncidentTimePanelItems';
import { InvolvedAgenciesPanelItem } from './InvolvedAgenciesPanelItem';
import { SummaryPanelItem } from './SummaryPanelItem';

export type IncidentSectionProps = {
  incidentId: string;
  incidentLabel: string | null;
  purpose: 'Real' | 'Test' | 'Demo';
  createdTimeUtc: string;
  closedTimeUtc: string | null;
  incidentIsReadOnly: boolean;
  incidentInvolvedAgencyStates: readonly IncidentAgency[];
  summary: string;
};

export function IncidentSection({
  incidentId,
  incidentLabel,
  purpose,
  createdTimeUtc,
  closedTimeUtc,
  incidentIsReadOnly,
  incidentInvolvedAgencyStates,
  summary,
}: IncidentSectionProps) {
  const { t } = useTranslation();
  const label = incidentLabel?.trim();

  return (
    <DataPanel
      header={label != null && label !== '' ? label : t('Incident_InfoPanel_IncidentHeader')}
      headerActions={
        incidentIsReadOnly ? null : (
          <NgButton
            icon="fal fa-edit"
            type="link"
            size="small"
            ariaLabel={t('Edit')}
            onClick={() => openEditIncidentLabelDialog(incidentId, incidentLabel)}
          />
        )
      }
      beforeItemsTemplate={
        purpose === 'Test' ? (
          <div className="d-flex px-2 pt-1">
            <IncidentPurposeBadge purpose={purpose} />
          </div>
        ) : null
      }
    >
      <IncidentTimePanelItems
        incidentId={incidentId}
        purpose={purpose}
        createdTimeUtc={createdTimeUtc}
        closedTimeUtc={closedTimeUtc}
        incidentIsReadOnly={incidentIsReadOnly}
      />

      <InvolvedAgenciesPanelItem
        createdTimeUtc={createdTimeUtc}
        closedTimeUtc={closedTimeUtc}
        incidentIsReadOnly={incidentIsReadOnly}
        incidentInvolvedAgencyStates={incidentInvolvedAgencyStates}
      />

      <SummaryPanelItem incidentId={incidentId} note={summary} incidentIsReadOnly={incidentIsReadOnly} />
    </DataPanel>
  );
}
